import React, { useEffect, useState } from "react";
// material
import { Grid, Container, CardHeader, CardContent } from "@mui/material";
import { useSelector } from "react-redux";
import { getProgressReportApprovalList } from "../core/service/progressReport.service";
import { getOutputSubmissionMentor } from "../core/service/outputSubmission.service";

// components
import Page from "../components/Page";

import {
  ApproveResTable,
  ConfirmationOutputSubmission
} from "../components/_dashboard/app";

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function ApproveResearch() {
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [listApproval, setListApproval] = useState([{}]);
  const { entities } = listApproval;

  const [listOutputSubmission, setListOutputSubmission] = useState([{}]);
  const entities_out = listOutputSubmission.entities;

  const progressReportApprovalList = async (id) => {
    const data = await getProgressReportApprovalList(id);
    setListApproval(data);
  };

  const outputSubmissionList = async (id) => {
    const data = await getOutputSubmissionMentor(id);
    setListOutputSubmission(data);
  };

  useEffect(() => {
    progressReportApprovalList(id);
    outputSubmissionList(id);
  }, []);

  return (
    <Page title="Approve Research">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            <ApproveResTable listApprove={entities || []} />
          </Grid>

          <Grid item xs={12} md={6} lg={12} sx={{ marginTop: 5 }}>
            <ConfirmationOutputSubmission confirm={entities_out || []} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
